import React from 'react';
import ReactDOM from 'react-dom/client';
// Import compiled CSS (run `npm run sass-watch` during development to auto-rebuild on save)
import './styles/main.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
